import React from 'react';
import c from 'classnames';
import { PapiComment } from '@wix/da-papi-types';
import UserLink from '../../../User/Link';
import s from './AuthorUserLink.scss';

interface Props {
  comment: PapiComment;
  className?: string;
}

/** A styled version of our user link. Looks different based on a couple PapiComment booleans (e.g. a featured variant). */
const AuthorUserLink: React.FC<Props> = ({ comment, className }) => {
  const { user, isAuthorHighlited, isFeatured } = comment;
  return (
    <UserLink
      withTooltip
      user={user}
      className={c(
        s['root'],
        isAuthorHighlited && s['highlight'],
        isFeatured && s['featured'],
        className
      )}
      relatedItemBiData={{
        typeid: comment.typeId,
        itemid: comment.itemId,
      }}
    />
  );
};
AuthorUserLink.displayName = 'AuthorUserLink';

export default AuthorUserLink;
